import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { disconnect_socket } from '@/actions';
import EventEmitter from '@/utils/eventEmitter';

const useLogoutTimer = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const logoutTimerRef = useRef(null);

  const resetTimer = () => {
    if (logoutTimerRef.current) {
      clearTimeout(logoutTimerRef.current);
    }
    const timer = setTimeout(() => {
      const pathname = window.location.pathname
      // 登录页不重置计时器, 非机器人网页不计时, 活动页不计时
      if (pathname === '/robot/login' || (pathname.indexOf('/robot') < 0) || (pathname.indexOf('/robot-activity') > -1)) {
        return;
      }
      // robotLogout();
      // 计时结束，发送事件，部分组件需要做额外处理，比如调用接口通知后端等
      EventEmitter.emit('confirmLogout')
    }, 5 * 60 * 1000); // 3分钟
    logoutTimerRef.current = timer;
  };

  // 机器人退出登录
  async function robotLogout() {
    const getEntryPath = localStorage.getItem('entrancePath');
    dispatch(disconnect_socket());
    localStorage.clear();
    if (getEntryPath) {
      localStorage.setItem('entrancePath', getEntryPath);
    };
    window.location.reload();
  }

  // 用户交互，重置定时器
  const handleUserInteraction = () => {
    resetTimer();
  };


  useEffect(() => {
    // 监听用户交互事件
    document.addEventListener('mousemove', handleUserInteraction);
    document.addEventListener('keydown', handleUserInteraction);
    // 监听用户语音输入或者语音播报
    EventEmitter.on('resetTimer', handleUserInteraction);
    EventEmitter.on('robotLogout', robotLogout);

    return () => {
      // 清除定时器和事件监听
      if (logoutTimerRef.current) {
        clearTimeout(logoutTimerRef.current);
      }
      document.removeEventListener('mousemove', handleUserInteraction);
      document.removeEventListener('keydown', handleUserInteraction);
      EventEmitter.removeListener('resetTimer', handleUserInteraction);
      EventEmitter.removeListener('robotLogout', robotLogout);
    };
  }, []);

  return null;
};

export default useLogoutTimer;
